import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '@/lib/utils';

interface DisclaimerBannerProps {
  variant?: 'default' | 'compact';
  dismissible?: boolean;
  onDismiss?: () => void;
}

export function DisclaimerBanner({
  variant = 'default',
  dismissible = false,
  onDismiss,
}: DisclaimerBannerProps) {
  const content = (
    <div
      className={cn(
        'bg-warning-50 border-b border-warning-200 px-4 py-3',
        variant === 'compact' ? 'py-2' : 'py-4'
      )}
    >
      <div className="max-w-6xl mx-auto flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <AlertTriangle className={cn('text-warning-600', variant === 'compact' ? 'w-4 h-4 mt-0.5' : 'w-5 h-5 mt-0.5')} />
          <div>
            <p className={cn('text-warning-800', variant === 'compact' ? 'text-sm' : 'text-base')}>
              <strong>Disclaimer:</strong>{' '}
              {variant === 'compact'
                ? 'This is NOT legal advice. Consult a real lawyer.'
                : 'This is NOT legal advice. We are not lawyers. Please consult a licensed attorney for actual legal matters. All content on this site is for entertainment purposes only.'}
            </p>
          </div>
        </div>
        {dismissible && (
          <button
            onClick={onDismiss}
            className="text-warning-600 hover:text-warning-800 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );

  return (
    <AnimatePresence>
      {content}
    </AnimatePresence>
  );
}

export function InlineDisclaimer({ className }: { className?: string }) {
  return (
    <div className={cn('inline-flex items-center space-x-2 text-xs text-surface-500 bg-surface-100 px-2 py-1 rounded-lg', className)}>
      <AlertTriangle className="w-3 h-3" />
      <span>Not legal advice</span>
    </div>
  );
}
